import {
  ModuleWithProviders,
  NgModule,
  Optional,
  Provider,
  SkipSelf,
} from '@angular/core';

import { PlRoutingService } from './services';

const PROVIDERS: Provider[] = [PlRoutingService];

@NgModule({
  declarations: [],
  imports: [],
})
export class PlUtilsModule {
  constructor(@Optional() @SkipSelf() authModule: PlUtilsModule) {
    if (authModule) {
      throw new TypeError(`PlUtilsModule is imported twice.`);
    }
  }

  static forRoot(): ModuleWithProviders<PlUtilsModule> {
    return {
      ngModule: PlUtilsModule,
      providers: PROVIDERS,
    };
  }
}
